export default __webpack_public_path__ + "static/media/pic3.2090461e.PNG";